import type { Trajectory } from './TrajectoryStore';

export interface ExportMeta {
  source?: string;
  resolution?: { width: number; height: number };
}

export function trajectoriesToJson(
  trajectories: readonly Trajectory[],
  meta: ExportMeta = {},
): string {
  return JSON.stringify(
    {
      exportedAt: new Date().toISOString(),
      source: meta.source,
      resolution: meta.resolution,
      trajectories: trajectories.map((t) => ({
        id: t.id,
        class: t.class,
        points: t.points,
      })),
    },
    null,
    2,
  );
}

export function trajectoriesToCsv(trajectories: readonly Trajectory[]): string {
  const rows: string[] = ['track_id,class,t_ms,x,y'];
  for (const traj of trajectories) {
    for (const p of traj.points) {
      rows.push(`${traj.id},${traj.class},${p.t.toFixed(3)},${p.x.toFixed(5)},${p.y.toFixed(5)}`);
    }
  }
  return rows.join('\n');
}
